import React from "react";
import {
  DatavizCloud,
  DatavizDoughnutChart,
  DatavizHorizontalBarChart,
  DatavizSunburst,
  DatavizTreeMap,
  isCloudDataviz,
  isHorizontalBarChartDataviz,
  isSunburstDataviz,
  isTreeMapDataviz,
} from "@radarly/models/dataviz";
import { getComparaisonPeriodFromFragments } from "@radarly/models/fragment";
import { SearchFragmentClassification } from "@radarly/models/search";
import { useFragmentsData } from "../data";
import Loading from "../loading";
import Cloud from "./cloud/inner";
import DoughnutChart from "./doughnut-chart/inner";
import HorizontalBarChart from "./horizontal-bar-chart/inner";
import Sunburst from "./sunburst/inner";
import TreeMap from "./tree-map/inner";

export interface SharedWidgetsClassificationInnerProps {
  project: number;
  fragment: SearchFragmentClassification;
  evolutionFragment?: SearchFragmentClassification;
  dataviz:
    | DatavizHorizontalBarChart
    | DatavizCloud
    | DatavizSunburst
    | DatavizTreeMap
    | DatavizDoughnutChart;
  className?: string;
  onClickItem?: (uid: string | number) => void;
  forceReload?: boolean;
  disableAnimation?: boolean;
  isFullscreen?: boolean;
  closeFullscreen?: () => void;
}

export default function SharedWidgetsClassificationInner({
  project,
  fragment,
  evolutionFragment,
  dataviz,
  forceReload,
  isFullscreen,
  closeFullscreen,
  onClickItem,
  ...props
}: SharedWidgetsClassificationInnerProps) {
  const comparisonPeriod = getComparaisonPeriodFromFragments(
    fragment,
    evolutionFragment
  );
  const { loading, data, comparaisonData } = useFragmentsData(
    project,
    fragment,
    evolutionFragment
  );
  const _onClickItem = (uid: string | number) => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClickItem(uid);
  };
  return (
    <Loading loading={loading} forceReload={forceReload}>
      {isCloudDataviz(dataviz) ? (
        <Cloud
          loading={loading}
          data={data}
          fragment={fragment}
          dataviz={dataviz}
          onClickItem={_onClickItem}
          {...props}
        />
      ) : isHorizontalBarChartDataviz(dataviz) ? (
        <HorizontalBarChart
          loading={loading}
          data={data}
          comparaisonData={comparaisonData}
          fragment={fragment}
          dataviz={dataviz}
          comparisonPeriod={comparisonPeriod}
          onClickItem={_onClickItem}
          {...props}
        />
      ) : isSunburstDataviz(dataviz) ? (
        <Sunburst
          loading={loading}
          data={data}
          fragment={fragment}
          dataviz={dataviz}
          onClickItem={_onClickItem}
          {...props}
        />
      ) : isTreeMapDataviz(dataviz) ? (
        <TreeMap
          loading={loading}
          data={data}
          fragment={fragment}
          dataviz={dataviz}
          onClickItem={_onClickItem}
          {...props}
        />
      ) : (
        <DoughnutChart
          loading={loading}
          data={data}
          fragment={fragment}
          {...props}
        />
      )}
    </Loading>
  );
}
